export default __webpack_public_path__ + "static/media/icon-filter-dropdown.3b47079b.svg";